import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=35e0b2fc&scoped=true"
import script from "./PageFooter.vue?vue&type=script&lang=ts"
export * from "./PageFooter.vue?vue&type=script&lang=ts"
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=35e0b2fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e0b2fc",
  null
  
)

export default component.exports